import { type ComponentType, type MemoExoticComponent, memo } from 'react';

/**
 * A convenience function for memoizing a component with a displayName, without
 * requiring the component to be defined as a named function or a separate
 * variable.
 *
 * @param {string} displayName The `displayName` to attach to the given `Component`
 * @param {Function} Component A function component to memoize
 * @param {Function} propsAreEqual An optional function that compares the previous and next props
 */
export function memoWithDisplayName<Props>(
  displayName: string,
  Component: ComponentType<Props>,
  propsAreEqual?: (
    prevProps: Readonly<Props>,
    nextProps: Readonly<Props>
  ) => boolean
): MemoExoticComponent<ComponentType<Props>> {
  Component.displayName = displayName;
  return memo(Component, propsAreEqual);
}
